import {useDimensions} from '../../contexts/dimensions/use-dimensions'
import {HamburgerNavBar} from './hamburger/hamburger-nav-bar'
import {FullWidthNavBar} from './full-width/full-width-nav-bar'

export function NavigationBar(): JSX.Element {
    const {width} = useDimensions()
    return (width || 0) <= 600 ? <HamburgerNavBar /> : <FullWidthNavBar />
}
